import React from "react";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";
import Messages from "./messages";
import SideActions from "./side-actions";
import CreateOneOTwoConversation from "./side-actions/create-one-o-two-conv";
import MarkAsReadButton from "./side-actions/MarkAsReadButton";
import ReactivateConversation from "./side-actions/ReactivateConversation";
import ReactivateKhattabaClient from "./side-actions/ReactivateKhattabaClient";
import getCorePersonalStore from "../../../../../stores/core/core-personal-store";
import getKhattabatSharedMessagingStore from "../../../../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";

const Body = withLiteObserverAndTheme<{
  conversationID: string;
  userID: number;
}>((props) => {
  const { theme, conversationID, userID } = props;
  const { isOpened } = getKhattabatSharedMessagingStore(conversationID);

  const { colors } = theme;

  const isConversationOpen = isOpened.get() === "OPENED";
  const isAiKhattaba = getCorePersonalStore().isKhattabaAiAdmin.get();

  return isConversationOpen ? (
    <ET3Div
      width={1450}
      height={0}
      alignItems={"center"}
      fDirection={"row"}
      style={{ backgroundColor: colors.all.white }}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={true}
      isScrollable={false}
      onClick={() => {}}
    >
      <Messages conversationID={conversationID} userID={userID} />
      <Et3Margin top={0} bottom={0} left={10} right={10} />
      {isAiKhattaba ? null : (
        <SideActions
          children={
            <React.Fragment>
              <MarkAsReadButton
                userID={userID}
                conversationID={conversationID}
              />
              <CreateOneOTwoConversation
                conversationID={conversationID}
                userID={userID}
              />
              <ReactivateKhattabaClient
                userID={userID}
                conversationID={conversationID}
              />
              <ReactivateConversation conversationID={conversationID} />
            </React.Fragment>
          }
        />
      )}
    </ET3Div>
  ) : null;
});

export default Body;
